import { useState } from "react"
import { useNavigate } from "react-router"
import { toast } from "react-toastify"
import Server from "../../Shared/Server"
import Spinner from "../../Shared/Spinner"
import {InputField} from "../../Shared/InputField"
import AsyncSelectField from "../../Shared/AsyncSelect"

const BranchForm = (props) => {
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [companyOptions, setCompanyOptions] = useState([]);

    const [formData, setFormData] = useState({
        company_id: "",
        email: "",
        name: "",
        category: "",
        unit: "",
        sms_username: "",
        sms_password: "",
        sender_name: "",
        status: "",
        logo: "",
        currency: "$",
        fee: "",
    })
    const {company_id, email, name, category, unit, sms_username, sms_password, sender_name, status, logo, currency, fee} = formData

    const navigate = useNavigate()

    const onChange = (e) => {
        setFormData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value
        }))
    }

    const loadOptions = async (url, query, setOptions) => {
        try {
            const response = await Server.get(`/options/${url}`, {
                params: { q: query },
            });
            setOptions(response.data);
            return response.data;
        } catch (error) {
            return [];
        }
    };

    const onSubmit = (e) => {
        e.preventDefault()

        const payload = {company_id, email, name, category, unit, sms_username, sms_password, sender_name, status, logo, currency, fee}
        addBranch(payload)
    }
    
    // add role
    const addBranch = async (payload) => {
        setIsLoading(true)
        try {
            const response = await Server.post('/branches/', payload)
            setIsLoading(false)
            if (response.status === 201){
                toast.success('Successfully created')
                navigate('/branches')
            }else{
                toast.error(response.data?.detail)
            }
        } catch (error) {
            setIsLoading(false)
            if(error.response.status === 401){
                navigate('/login')
            }else if (error.response.status === 422){
                setErrors({})
                error.response?.data?.detail.map((err) => (
                    setErrors((prevState) => ({
                        ...prevState,
                        [err.loc[1]]: err.msg
                    }))
                ))
            }else if (error.response.status === 403){
                toast.error(error.response.data.detail);
                navigate('/');
            }else {
                toast.error(error.response.data?.detail)
            }
        }
    }

    if(isLoading){
        return <Spinner/>
    }

  return (
    <>
        <div className="card">
            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                <h3 className="card-title">Create Branch</h3>
            </div>
            <div className="card-body">
                <form onSubmit={onSubmit}>
                    <div className="row">
                        <div className="col-md-3">
                            <AsyncSelectField
                                name="company_id"
                                label="Company"
                                value={company_id}
                                onChange={onChange}
                                loadOptions={(query) => loadOptions('companies', query, setCompanyOptions)}
                                options={companyOptions}
                                placeholder="Start typing to search..."
                                error={errors.company_id}
                            />
                        </div>
                        <div className="col-md-3">
                            <InputField
                                placeholder="Name"
                                name="name"
                                type="text"
                                label="Name"
                                value={name}
                                onChange={onChange}
                                error={errors.name}
                            />
                        </div>
                        <div className="col-md-3">
                            <InputField
                                placeholder="Category"
                                name="category"
                                type="text"
                                label="Category"
                                value={category}
                                onChange={onChange}
                                error={errors.category}
                            />
                        </div>
                        <div className="col-md-3">
                            <InputField
                                placeholder="Fee"
                                name="fee"
                                type="number"
                                label="Monthly Fee"
                                value={fee}
                                onChange={onChange}
                                error={errors.fee}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3">
                            <InputField
                                placeholder="Unit"
                                name="unit"
                                type="text"
                                label="Unit"
                                value={unit}
                                onChange={onChange}
                                error={errors.unit}
                            />
                        </div>
                        <div className="col-md-3">
                            <InputField
                                placeholder="SMS UserName"
                                name="sms_username"
                                type="text"
                                label="SMS UserName"
                                value={sms_username}
                                onChange={onChange}
                                error={errors.sms_username}
                            />
                        </div>
                        <div className="col-md-3">
                            <InputField
                                placeholder="SMS Passowrd"
                                name="sms_password"
                                type="text"
                                label="SMS Passowrd"
                                value={sms_password}
                                onChange={onChange}
                                error={errors.sms_password}
                            />
                        </div>
                        <div className="col-md-3">
                            <InputField
                                placeholder="Sender Name"
                                name="sender_name"
                                type="text"
                                label="SenderName"
                                value={sender_name}
                                onChange={onChange}
                                error={errors.sender_name}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3">
                            <InputField
                                placeholder="Status"
                                name="status"
                                type="text"
                                label="Status"
                                value={status}
                                onChange={onChange}
                                error={errors.status}
                            />
                        </div>
                        <div className="col-md-3">
                            <InputField
                                placeholder="Logo"
                                name="logo"
                                type="text"
                                label="Logo"
                                value={logo}
                                onChange={onChange}
                                error={errors.logo}
                            />
                        </div>
                        <div className="col-md-3">
                            <InputField
                                placeholder="Currency"
                                name="currency"
                                type="text"
                                label="Currency"
                                value={currency}
                                onChange={onChange}
                                error={errors.currency}
                            />
                        </div>
                        <div className="col-md-3">
                            <InputField
                                placeholder="Email"
                                name="email"
                                type="email"
                                label="Email"
                                value={email}
                                onChange={onChange}
                                error={errors.email}
                            />
                        </div>
                    </div>
                    <br/>
                    <div className="row">
                        <div className="col-md-12">
                            <input type="submit" className="btn btn-outline-info" value="Save Branch" style={{float: 'right'}}/>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <br/>
    </>
  )
}

export default BranchForm
